var map = {
	"./elefantinho_agudos_I/elefantinho_agudos_I_1.png": 3446,
	"./elefantinho_agudos_I/elefantinho_agudos_I_2.png": 5069,
	"./elefantinho_agudos_I/elefantinho_agudos_I_3.png": 5124,
	"./elefantinho_agudos_II/elefantinho_agudos_II_1.png": 2574,
	"./elefantinho_agudos_II/elefantinho_agudos_II_2.png": 4373,
	"./elefantinho_agudos_II/elefantinho_agudos_II_3.png": 4956,
	"./elefantinho_chapadao/elefantinho_chapadao_1.png": 334,
	"./elefantinho_chapadao/elefantinho_chapadao_2.png": 1813,
	"./elefantinho_esmeralda/elefantinho_esmeralda_1.png": 1786,
	"./elefantinho_esmeralda/elefantinho_esmeralda_2.png": 1953,
	"./elefantinho_esmeralda/elefantinho_esmeralda_3.png": 7736,
	"./elefantinho_garca/elefantinho_garca_1.png": 3870,
	"./elefantinho_garca/elefantinho_garca_2.png": 9621,
	"./elefantinho_garca/elefantinho_garca_3.png": 6732,
	"./elefantinho_lencois/elefantinho_lencois_1.png": 806,
	"./elefantinho_lencois/elefantinho_lencois_2.png": 2573,
	"./elefantinho_lencois/elefantinho_lencois_3.png": 9332,
	"./elefantinho_marilia_eskinao_I/elefantinho_marilia_eskinao_I_1.png": 5638,
	"./elefantinho_marilia_eskinao_I/elefantinho_marilia_eskinao_I_2.png": 5965,
	"./elefantinho_marilia_eskinao_I/elefantinho_marilia_eskinao_I_3.png": 2068,
	"./elefantinho_marilia_eskinao_II/elefantinho_marilia_eskinao_II_1.png": 5406,
	"./elefantinho_marilia_eskinao_II/elefantinho_marilia_eskinao_II_2.png": 7509,
	"./elefantinho_marilia_eskinao_II/elefantinho_marilia_eskinao_II_3.png": 4620,
	"./elefantinho_marilia_eskinao_III/elefantinho_marilia_eskinao_III_1.png": 4778,
	"./elefantinho_marilia_eskinao_III/elefantinho_marilia_eskinao_III_2.png": 5889,
	"./elefantinho_marilia_eskinao_III/elefantinho_marilia_eskinao_III_3.png": 5672,
	"./elefantinho_marilia_eskinao_IV/elefantinho_marilia_eskinao_IV_1.png": 8540,
	"./elefantinho_marilia_eskinao_IV/elefantinho_marilia_eskinao_IV_2.png": 8599,
	"./elefantinho_marilia_eskinao_IV/elefantinho_marilia_eskinao_IV_3.png": 6638,
	"./elefantinho_pampulha/elefantinho_pampulha_1.png": 9220,
	"./elefantinho_pampulha/elefantinho_pampulha_2.png": 3871,
	"./elefantinho_pampulha/elefantinho_pampulha_3.png": 7542,
	"./elefantinho_premium_comendador/elefantinho_premium_comendador_1.png": 716,
	"./elefantinho_premium_comendador/elefantinho_premium_comendador_2.png": 8823,
	"./elefantinho_premium_comendador/elefantinho_premium_comendador_3.png": 3246,
	"./elefantinho_premium_nacoes/elefantinho_premium_nacoes_1.png": 6214,
	"./elefantinho_premium_nacoes/elefantinho_premium_nacoes_2.png": 6893,
	"./elefantinho_premium_nacoes/elefantinho_premium_nacoes_3.png": 4388,
	"./elefantinho_rodrigues_I/elefantinho_rodrigues_I_1.png": 5278,
	"./elefantinho_rodrigues_I/elefantinho_rodrigues_I_2.png": 5653,
	"./elefantinho_rodrigues_I/elefantinho_rodrigues_I_3.png": 4028,
	"./elefantinho_rodrigues_II/elefantinho_rodrigues_II_1.png": 4062,
	"./elefantinho_rodrigues_II/elefantinho_rodrigues_II_2.png": 1413,
	"./elefantinho_rodrigues_II/elefantinho_rodrigues_II_3.png": 5964,
	"./elefantinho_sao_geraldo/elefantinho_sao_geraldo_1.png": 5698,
	"./elefantinho_sao_geraldo/elefantinho_sao_geraldo_2.png": 3881,
	"./elefantinho_sao_geraldo/elefantinho_sao_geraldo_3.png": 9680,
	"./elefantinho_vista_alegre/elefantinho_vista_alegre_1.png": 7524,
	"./elefantinho_vista_alegre/elefantinho_vista_alegre_2.png": 1087,
	"./elefantinho_vista_alegre/elefantinho_vista_alegre_3.png": 2998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2280;